import { ReactElement } from 'react';

import { FileView, FileViewProps } from '@hh.ru/magritte-ui-upload/FileView';
import { useFilePreview } from '@hh.ru/magritte-ui-upload/useFilePreview';
import { getFileType } from '@hh.ru/magritte-ui-upload/utils';

import styles from './file-viev-with-preview.less';

type FileViewWithPreviewProps = Omit<FileViewProps, 'preview' | 'uploadType'>;

const FileViewWithPreview = ({ loadedFile, ...otherProps }: FileViewWithPreviewProps): ReactElement => {
    const uploadType = getFileType(loadedFile.data.type);
    const preview = useFilePreview({ loadedFile, isImageType: uploadType === 'image' });
    return (
        <div className={styles.item}>
            <FileView uploadType={uploadType} loadedFile={loadedFile} preview={preview} {...otherProps} />
        </div>
    );
};

export { FileViewWithPreview };
